export const TRANSACTION_TYPE = ["deposit", "withdrawal", "payment", "invoice"];
